// removed by extract-text-webpack-plugin
module.exports = {"chip":"Chip-module__chip___1x8QA"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/Chip/Chip.module.css
// module id = 646
// module chunks = 0